export const hallsData = {
  A: {
    id: 'A',
    title: 'Gebäude A',
    subtitle: 'Derzeit nicht verfügbar',
    image: 'https://media.wasacon.de/kueppers-gewerbeeinheiten/_assets/media/b211e2c6acc399045347f7fa95bbdb6b.jpg',
    status: 'unavailable',
    specs: [],
    description: 'Diese Fläche ist aktuell vermietet.'
  },
  B: {
    id: 'B',
    title: 'Gebäude B',
    subtitle: 'Derzeit nicht verfügbar',
    image: 'https://images.unsplash.com/photo-1504307651254-35680f356f12?q=80&w=800&auto=format&fit=crop',
    status: 'unavailable',
    specs: [],
    description: 'Diese Fläche ist aktuell vermietet.'
  },
  C: {
    id: 'C',
    title: 'Produktionshalle C',
    subtitle: 'Kombinierte Nutzfläche',
    image: 'https://media.wasacon.de/kueppers-gewerbeeinheiten/_assets/media/e64e4284eccd5715c2512958efe43f2f.jpg',
    gallery: [
      'https://media.wasacon.de/kueppers-gewerbeeinheiten/_assets/media/e64e4284eccd5715c2512958efe43f2f.jpg',
      'https://media.wasacon.de/kueppers-gewerbeeinheiten/_assets/media/c58fd8c8afacc37c44fa5685873db30f.jpg',
      'https://media.wasacon.de/kueppers-gewerbeeinheiten/_assets/media/391d101e30ce924bf559aaaac3286239.jpg',
      'https://media.wasacon.de/kueppers-gewerbeeinheiten/_assets/media/093f547f6becbdc0b122d27af80966ad.jpg',
      'https://media.wasacon.de/kueppers-gewerbeeinheiten/_assets/media/0422cb9686816931c088d97551433cfc.jpg',
      'https://media.wasacon.de/kueppers-gewerbeeinheiten/_assets/media/bdc2e7e1d013563120594e01e89872c3.jpg',
      'https://media.wasacon.de/kueppers-gewerbeeinheiten/_assets/media/00862f3ced2193473476edcefb1b39b3.jpg',
      'https://media.wasacon.de/kueppers-gewerbeeinheiten/_assets/media/b211e2c6acc399045347f7fa95bbdb6b.jpg',
      'https://media.wasacon.de/kueppers-gewerbeeinheiten/_assets/media/e7f98c342b632c10738ffc9a0792e19c.jpg'
    ],
    status: 'available',
    specs: [
      { label: 'Halle', value: '280 m²' },
      { label: 'Büro', value: '72 m²' },
      { label: 'Ausstattung', value: 'Aufenthaltsraum, Sanitäranlagen' }
    ],
    description: 'Kompakte und gut ausgestattete Produktionshalle mit direkt angeschlossenem Bürotrakt. Die hellen Räumlichkeiten bieten optimale Bedingungen für Produktion und Verwaltung unter einem Dach.'
  },
  D: {
    id: 'D',
    title: 'Halle D',
    subtitle: 'Derzeit nicht verfügbar',
    image: 'https://media.wasacon.de/kueppers-gewerbeeinheiten/_assets/media/72562eaaca6d0621ef0ac490a941f32e.jpg',
    status: 'unavailable',
    specs: [],
    description: 'Diese Fläche ist aktuell vermietet.'
  },
  E: {
    id: 'E',
    title: 'Lagerhalle E',
    subtitle: 'Derzeit nicht verfügbar',
    image: 'https://media.wasacon.de/kueppers-gewerbeeinheiten/_assets/media/76cd59b37b0da772c4f378f4bc7cada0.jpg',
    status: 'unavailable',
    specs: [],
    description: 'Diese Fläche ist aktuell vermietet.'
  },
  F: {
    id: 'F',
    title: 'Lagerhalle F',
    subtitle: 'Derzeit nicht verfügbar',
    image: 'https://media.wasacon.de/kueppers-gewerbeeinheiten/_assets/media/ff9d503fdbea376078a0e79f48ea0ff1.jpg',
    status: 'unavailable',
    specs: [],
    description: 'Diese Fläche ist aktuell vermietet.'
  },
  G: {
    id: 'G',
    title: 'Produktionshalle G',
    subtitle: 'Derzeit nicht verfügbar',
    image: 'https://media.wasacon.de/kueppers-gewerbeeinheiten/_assets/media/8a149fc504d63e312111bbe4acf02fcf.jpg',
    status: 'unavailable',
    specs: [],
    description: 'Diese Fläche ist aktuell vermietet.'
  }
};